import script from "./ReservaPase.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservaPase.vue?vue&type=script&setup=true&lang=js"

import "./ReservaPase.vue?vue&type=style&index=0&id=502bc4c1&lang=css"

const __exports__ = script;

export default __exports__